"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@material/data-table/dist/mdc.data-table.css");
require("@rmwc/data-table/data-table.css");
require("@rmwc/icon/styles");
